// import { createContext, useEffect, useReducer } from 'react';
// import firebase from 'src/utils/firebase';
// import PropTypes from 'prop-types';

// const initialAuthState = {
//   isAuthenticated: false,
//   isInitialized: false,
//   user: null
// };

// const reducer = (state, action) => {
//   if (action.type === 'AUTH_STATE_CHANGED') {
//     const { isAuthenticated, user } = action.payload;

//     return {
//       ...state,
//       isAuthenticated,
//       isInitialized: true,
//       user
//     };
//   }

//   return state;
// };

// const AuthContext = createContext({
//   ...initialAuthState,
//   method: 'FirebaseAuth',
//   createUserWithEmailAndPassword: () => Promise.resolve(),
//   signInWithEmailAndPassword: () => Promise.resolve(),
//   signInWithGoogle: () => Promise.resolve(),
//   logout: () => Promise.resolve()
// });

// export const AuthProvider = (props) => {
//   const { children } = props;
//   const [state, dispatch] = useReducer(reducer, initialAuthState);

//   useEffect(
//     () =>
//       firebase.auth().onAuthStateChanged((user) => {
//         if (user) {
//           dispatch({
//             type: 'AUTH_STATE_CHANGED',
//             payload: {
//               isAuthenticated: true,
//               user: {
//                 id: user.uid,
//                 jobtitle: 'Cat',
//                 avatar: user.photoURL,
//                 email: user.email,
//                 name: user.displayName || user.email,
//                 role: 'admin',
//                 location: 'San Francisco, USA',
//                 username: 'admin',
//                 posts: '4',
//                 coverImg: '/static/images/placeholders/covers/1.jpg',
//                 followers: '5684',
//                 description:
//                   'Lorem ipsum is placeholder text commonly used in the graphic.'
//               }
//             }
//           });
//         } else {
//           dispatch({
//             type: 'AUTH_STATE_CHANGED',
//             payload: {
//               isAuthenticated: false,
//               user: null
//             }
//           });
//         }
//       }),
//     [dispatch]
//   );

//   const signInWithEmailAndPassword = (email, password) => {
//     return firebase.auth().signInWithEmailAndPassword(email, password);
//   };

//   const signInWithGoogle = () => {
//     const provider = new firebase.auth.GoogleAuthProvider();

//     return firebase.auth().signInWithPopup(provider);
//   };

//   const createUserWithEmailAndPassword = async (email, password) => {
//     return firebase.auth().createUserWithEmailAndPassword(email, password);
//   };

//   const logout = () => {
//     return firebase.auth().signOut();
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         ...state,
//         method: 'FirebaseAuth',
//         createUserWithEmailAndPassword,
//         signInWithEmailAndPassword,
//         signInWithGoogle,
//         logout
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// AuthProvider.propTypes = {
//   children: PropTypes.node.isRequired
// };

// export default AuthContext;
import { createContext, useEffect, useReducer } from 'react';
import firebase from 'src/utils/firebase';
import { getDb }from 'src/utils/firebase';
import PropTypes from 'prop-types';

const initialAuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const reducer = (state, action) => {
  if (action.type === 'AUTH_STATE_CHANGED') {
    const { isAuthenticated, user } = action.payload;

    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  }

  return state;
};

const AuthContext = createContext({
  ...initialAuthState,
  method: 'FirebaseAuth',
  createUserWithEmailAndPassword: () => Promise.resolve(),
  signInWithEmailAndPassword: () => Promise.resolve(),
  signInWithGoogle: () => Promise.resolve(),
  logout: () => Promise.resolve()
});

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialAuthState);
  const db = getDb();

  useEffect(() => {
    let unsubscribeUserDoc;  // Declare without initializing

    const unsubscribeAuth = firebase.auth().onAuthStateChanged((user) => {
      if (unsubscribeUserDoc) {
        // Unsubscribe from previous user document listener if it exists
        unsubscribeUserDoc();
      }

      if (user) {
        // Subscribe to new user document based on the user's ID
        unsubscribeUserDoc = db
          .collection('users')
          .doc(user.uid)
          .onSnapshot((doc) => {
            if (doc.exists) {
              console.log(doc.data());
              dispatch({
                type: 'AUTH_STATE_CHANGED',
                payload: {
                  isAuthenticated: true,
                  user: {
                    ...doc.data(),
                    uid: user.uid,
                  },
                },
              });
            }
          });
      } else {
        dispatch({
          type: 'AUTH_STATE_CHANGED',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    });

    // Cleanup
    return () => {
      unsubscribeAuth();
      if (unsubscribeUserDoc) {
        unsubscribeUserDoc();
      }
    };
  }, [dispatch]);

  const signInWithEmailAndPassword = (email, password) => {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  };

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  };

  const createUserWithEmailAndPassword = async (email, password) => {
    return firebase.auth().createUserWithEmailAndPassword(email, password);
  };

  const logout = () => {
    return firebase.auth().signOut();
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'FirebaseAuth',
        createUserWithEmailAndPassword,
        signInWithEmailAndPassword,
        signInWithGoogle,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthContext;
